var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.upsell
    ? _c(
        "div",
        {
          ref: "upsellItem",
          staticClass: "cart_item_upsell",
          class: { _show: _vm.upsell.show, _animate_in: _vm.upsell.new },
        },
        [
          _c("button", {
            staticClass: "cart_item_upsell_close css_cross",
            attrs: { "aria-label": "Dismiss upsell" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.dismiss()
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "cart_item_upsell_announcer" }, [
            _vm._v("Get the set!"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cart_item_upsell_content" }, [
            _c(
              "a",
              {
                staticClass: "cart_item_upsell_image_col",
                attrs: { href: _vm.upsell.url },
              },
              [
                _c("img", {
                  staticClass: "_self_loading_image",
                  class: { _loaded: _vm.itemImageLoaded },
                  style: {
                    background: _vm.utils.getSizedImageUrl(
                      _vm.upsell.featured_image,
                      "1x"
                    ),
                  },
                  attrs: {
                    alt: `${_vm.upsell.title}`,
                    src: _vm.utils.getSizedImageUrl(
                      _vm.upsell.featured_image,
                      "200x"
                    ),
                  },
                  on: { load: () => (_vm.itemImageLoaded = true) },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "cart_item_upsell_details" }, [
              _c("a", { attrs: { href: _vm.upsell.url } }, [
                _vm._v("\n        " + _vm._s(_vm.upsell.title) + "\n      "),
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$options.filters.withCurrency(
                      _vm.$options.filters.money(_vm.upsell.price)
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cart_item_upsell_buy_buttons" },
                _vm._l(_vm.upsell.variants, function (variant) {
                  return _c(
                    "button",
                    {
                      staticClass: "single_buy_button",
                      attrs: { disabled: !variant.available },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.add(variant.id)
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(variant.title))])]
                  )
                }),
                0
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }